module.exports = __webpack_public_path__ + "img/Edit.b59183a6.svg";